


const locales = {
    en: {
        municipality: 'municipality',
        producers: 'producers',
        selectOne: 'Select One',
        reset: 'Reset',
        agaveLookup: 'Agave Lookup',
        species: 'Species',
        subspecies: 'subspecies',
        commonNames: 'Common names:',
        speciesNames: 'Species names:',
        understanding: 'UNDERSTANDING',
        mezcal: 'MEZCAL',
        mezcalMaps: 'Mezcal Maps',
        agaveSearch: 'Agave Search',
        producerSearch: 'Producer Search',
        about: 'About',
        producerLookup: 'Producer Lookup',
        producer: 'producer',
        location: 'Location:',
        state: 'State:',
        region: 'Region:',
        associatedBrands: 'Associated Brands:',
        otherProducers: 'Other producers in ',
        onlyProducerListed: ' is the only producer listed in ',
        brand: 'brand',
        producersLabel: 'Producers:',
        referenceGuide: 'reference guide',
        aGuideToBrands: 'a guide to mezcal brands,',
        andMoreImportantly: 'and more importantly, to',
        thePeopleWho: 'the people who make them',
        distillation: 'distillation',
        fermenters: 'fermenters',


    },
    es: {
        municipality: 'municipio',
        producers: 'productores',
        selectOne: 'Seleccione uno',
        reset: 'Clarar',
        agaveLookup: 'Búsqueda de Agave',
        species: 'Especie',
        subspecies: 'subespecies',
        commonNames: 'Nombres comunes:',
        speciesNames: 'Nombres científicos:',
        understanding: 'Acercándonos al',
        mezcal: 'MEZCAL',
        mezcalMaps: 'Mapas de Mezcal',
        agaveSearch: 'Búsqueda de Agave',
        producerSearch: 'Búsqueda de Productores',
        about: 'Más Información',
        producerLookup: 'Búsqueda de Productores',
        producer: 'productor',
        location: 'Ubicación:',
        state: 'Estado:',
        region: 'Región:',
        associatedBrands: 'Marcas Asociadas:',
        otherProducers: 'Otros productores en ',
        onlyProducerListed: ' es el único productor listado en ',
        brand: 'marca',
        producersLabel: 'Productores:',
        referenceGuide: 'guía de referencia',
        aGuideToBrands: 'una guía de marcas de mezcal,',
        andMoreImportantly: 'y más importante las',
        thePeopleWho: 'personas que los hace',
        distillation: 'destilación',
        fermenters: 'tinas',
    },
}

export default locales

